var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("div", {
        staticClass: "fixed top-0 left-0 w-full h-full z-20",
        class: _vm.backgroundStyle,
        on: {
          click: function ($event) {
            return _vm.$emit("close")
          },
        },
      }),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }